// extracted by mini-css-extract-plugin
module.exports = {"next":"next-T7zLF","disabled":"disabled-zrtPx","previous":"previous-kOSVm","wrapper":"wrapper-c9LmT","with_messages":"with_messages-oYtod","editor_content":"editor_content-KBd_h"};